import script from "./TutorsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./TutorsPage.vue?vue&type=script&setup=true&lang=js"

import "./TutorsPage.vue?vue&type=style&index=0&id=372e2760&lang=css"

const __exports__ = script;

export default __exports__